import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { AuthService } from '../../core/security/auth.service';
import { CallLogsService as CallLogsApiService } from '../../api/services/call-logs.service';
import { RecordingsV2Service as RecordingsV2ApiService } from '../../api/services/recordings-v-2.service';
import { NotificationService } from '../../notification/notification.service';
import { ExportCallLogsRequest } from '../../api/models/export-call-logs-request';
import { ExportFieldModel } from '../../api/models/export-field-model';
import { CallLogModel } from '../../api/models/call-log-model';
import { CallLogRequest } from '../../api/models/call-log-request';

@Injectable()
export class CallLogsV2Service {
  public exportColumns: ExportFieldModel[] = [
    { id: _.uniqueId('id_'), field: 'domainAlias', title: 'Company', width: 20 },
    {
      id: _.uniqueId('id_'),
      field: 'start',
      title: 'Date & Time',
      width: 20,
      style: { numFmt: 'DD/MM/YYYY hh:mm:ss AM/PM' },
    },
    { id: _.uniqueId('id_'), field: 'fromFull', title: 'From', width: 20 },
    { id: _.uniqueId('id_'), field: 'toFull', title: 'To', width: 20 },
    { id: _.uniqueId('id_'), field: 'callType', title: 'Type', width: 10 },
    { id: _.uniqueId('id_'), field: 'callStatus', title: 'Call Result', width: 10 },
    { id: _.uniqueId('id_'), field: 'reasonH', title: 'Missed Reason', width: 10 },
    { id: _.uniqueId('id_'), field: 'answeredByH', title: 'Answered By', width: 10 },
    { id: _.uniqueId('id_'), field: 'missedByH', title: 'Missed By', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationTalkFormatted', title: 'Talk Time', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationTotalFormatted', title: 'Total Time', width: 10 },
  ];

  public exportAdditionalColumns: ExportFieldModel[] = [
    { id: _.uniqueId('id_'), field: 'durationIvrFormatted', title: 'IVR Time', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationRingFormatted', title: 'Ring Time', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationHoldFormatted', title: 'Hold Time', width: 10 },
    // {id: _.uniqueId('id_'), field: 'durationIdleFormatted', title: 'Idle Time', width: 10},
  ];



  public allExportColumns: any[] = [];

  constructor(
    private authService: AuthService,
    private notificationsService: NotificationService,
    private callLogsApiService: CallLogsApiService,
    private recordingsV2ApiService: RecordingsV2ApiService,
  ) {
    this.allExportColumns = this.exportColumns.concat(this.exportAdditionalColumns);
  }

  public getExportColumns(includeAdditionalColumns) {
    return includeAdditionalColumns ? this.exportColumns.concat(this.exportAdditionalColumns) : this.exportColumns;
  }

  public async getCallDetails(callId: string, domain: string): Promise<any> {
    return await this.callLogsApiService
      .callLogsV2GetRawCallDetails({
        body: {
          callId: callId,
          domain: domain,
        },
      })
      .toPromise();
  }

  public async exportLogs(state: ExportCallLogsRequest): Promise<void> {
    await this.callLogsApiService.callLogsV2GetExport({ body: state }).toPromise();
    this.notificationsService.notifySuccess(
      'Export is in progress. You will get notification then download is finished.',
    );
    return;
  }

  async deleteRecording(
    callRecId: string,
    recId: string,
    domain: string,
    cdrDate: string,
    deleteTranscription: boolean,
    deleteRecording: boolean,
  ) {
    await this.recordingsV2ApiService
      .recordingsV2DeleteRecording({
        callId: callRecId,
        recordingId: recId,
        domain: domain,
        cdrDate: cdrDate,
        deleteTranscription,
        deleteRecording,
      })
      .toPromise();
  }

  async getCallFlowDetails(filter: CallLogRequest): Promise<CallLogModel> {
    const result = await this.callLogsApiService.callLogsV2GetCallFlowDetails({ body: filter }).toPromise();
    return result;
  }
}
